import _ from 'lodash';

import ConversationMessageCompositionContent from 'models/composition/conversation_message_composition_content';
import CreateComposition from 'actions/composition/lib/create_composition';
import { getLatestManualItem } from 'scripts/application/lib/conversation_history_helpers';
import { MessageChannelType } from 'models/conversation_message';
import {
  canCreateInstagramComposition,
  getInstagramFromAddresses,
  normalizeInstagramHandle,
} from 'actions/composition/lib/instagram_composition_helpers';

class CreateInstagramComposition extends CreateComposition {
  constructor(context) {
    super(context, ConversationMessageCompositionContent);
  }

  _createContent(attrs) {
    const channelDisplayTitle = 'Instagram Messaging';
    const lastInstagramItem = this._findLastInstagramItem(attrs.conversationId);
    const conversation = this.customerStores.conversations.find(attrs.conversationId);

    const potentialFroms = this._getPotentialFroms(conversation);
    let companyAddress = _.get(potentialFroms, 'default.id');
    let companyHandle = _.get(potentialFroms, 'default.handle');
    if (lastInstagramItem) {
      const matchedAddress = _.find(potentialFroms.allFromAddresses, [
        'id',
        _.get(lastInstagramItem, 'content.companyAddress'),
      ]);
      if (matchedAddress) {
        companyAddress = matchedAddress.id;
        companyHandle = matchedAddress.handle;
      }
    }

    const companyDisplayName = normalizeInstagramHandle(companyHandle);

    const instagramAddresses = this.customerStores.profile.get().getCustomerInstagramAddresses();
    const customerAddress = lastInstagramItem ? lastInstagramItem.content.customerAddress : instagramAddresses[0]?.id;
    const customerDisplayName =
      instagramAddresses.find(address => address.id === customerAddress)?.displayName ||
      instagramAddresses[0]?.displayName;

    return new ConversationMessageCompositionContent({
      channel: MessageChannelType.INSTAGRAM_DIRECT,
      channelDisplayTitle,
      companyAddress,
      companyDisplayName,
      customerAddress,
      customerDisplayName,
    });
  }

  _canCreateComposition() {
    return canCreateInstagramComposition(this.context, config => config?.companyInstagramAddresses?.());
  }

  _getPotentialFroms(conversation) {
    const channelConfiguration = this.context.stores.channelConfiguration.get();
    const instagramEndpoints = channelConfiguration
      ? channelConfiguration.getEndpointsOfType(MessageChannelType.INSTAGRAM_DIRECT)
      : [];
    const allFromAddresses = instagramEndpoints.map(endpoint => ({
      handle: endpoint.configuration.handle,
      id: endpoint.address,
    }));
    const routingGroupId = conversation.assignee.routingGroupId;

    return getInstagramFromAddresses({
      context: this.context,
      allFromAddresses,
      conversation,
      endpoints: instagramEndpoints,
      endpointType: MessageChannelType.INSTAGRAM_DIRECT,
      routingGroupId,
    });
  }

  _findLastInstagramItem(conversationId) {
    const customerId = this.context.stores.currentLocation.get().customerId;
    const { conversationHistory } = this.context.stores.customers.storesFor(customerId);
    return getLatestManualItem({
      conversationHistory,
      filter: item => item.content.channel === MessageChannelType.INSTAGRAM_DIRECT,
      conversationId,
    });
  }
}

export default CreateInstagramComposition;
